import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlag } from '../../../shared/models/enums/feature-flag';
import { DocumentTypeLevelType as LegacyDocumentTypeLevelType } from '../../models/requirement-descriptions.model';
import { RequirementOverrideDetail } from '../../models/requirement-override-detail.model';
import { SaveRequirementOverrideRequest } from '../../models/save-requirement-override-request.model';
import { RequirementsOverrideService } from '../../shared/requirements-override/requirements-override.service';
import { DocumentTypeLevelType } from '../enums/document-type-level-type.enum';
import { RequirementQualificationSettingOverrideDetailsDto } from '../models/requirement-qualification-setting-override-details-dto.model';
import { SaveQualificationSettingsOverrideRequest } from '../models/save-qualification-settings-override-request.model';
import { RequirementQualificationSettingOverrideClient } from '../requirement-qualification-setting-override-client.service';
import { NSwagMigrationService } from './nswag-migration.service';

// 3 endpoints
@Injectable({ providedIn: 'root' })
export class RequirementsOverrideNSwagMigrationService extends NSwagMigrationService {
    protected readonly className = 'RequirementsOverrideNSwagMigrationService';
    protected readonly featureFlag = FeatureFlag.NSwagMigrationRequirementsOverrideService;
    private readonly legacy = inject(RequirementsOverrideService);
    private readonly requirementQualificationSettingOverrideClient = inject(RequirementQualificationSettingOverrideClient);

    // ** RequirementQualificationSettingOverrideController.GetRequirementOverrideDetailsAsync
    getRequirementOverrideDetail(
        documentTypeId: number,
        entityType: LegacyDocumentTypeLevelType | DocumentTypeLevelType,
        entityId: number
    ): Observable<RequirementOverrideDetail | RequirementQualificationSettingOverrideDetailsDto> {
        return this.invoke(x => x
            ? this.legacy.getRequirementOverrideDetail(documentTypeId, entityType as LegacyDocumentTypeLevelType, entityId)
            : this.requirementQualificationSettingOverrideClient.getRequirementOverrideDetails(documentTypeId, entityType as DocumentTypeLevelType, entityId));
    }

    // ** RequirementQualificationSettingOverrideController.SaveRequirementOverrideAsync
    saveRequirementOverride(request: SaveRequirementOverrideRequest | SaveQualificationSettingsOverrideRequest): Observable<void> {
        return this.invoke(x => x
            ? this.legacy.saveRequirementOverride(request as SaveRequirementOverrideRequest)
            : this.requirementQualificationSettingOverrideClient.saveRequirementOverride(request.documentTypeId, request as SaveQualificationSettingsOverrideRequest));
    }

    // ** RequirementQualificationSettingOverrideController.DeleteRequirementOverrideAsync
    deleteRequirementOverride(documentTypeId: number, entityType: LegacyDocumentTypeLevelType | DocumentTypeLevelType, entityId: number): Observable<void> {
        return this.invoke(x => x
            ? this.legacy.deleteRequirementOverride(documentTypeId, entityType as LegacyDocumentTypeLevelType, entityId)
            : this.requirementQualificationSettingOverrideClient.deleteRequirementOverride(documentTypeId, entityType as DocumentTypeLevelType, entityId));
    }
}
